import { useNavigate } from "react-router-dom";
import { Button, Col, Row } from "react-bootstrap";
import { ModelState, ProductRangeState } from "../../../routing/RoutingStates";
import { INextButtonProps } from "../FrontPageInterfaces";
export default function NextButton({
  selectedCompany,
  isProductCompany,
  selectedRadio,
  serialNumber,
}: INextButtonProps) {
  const navigate = useNavigate();

  const handleNext = () => {
    const productRangeState: ProductRangeState = {
      selectedCompany,
      isProductCompany,
    };
    const modelState: ModelState = {
      selectedCompany,
      isProductCompany,
      selectedProductRange: null,
    };
    switch (selectedRadio) {
      case "product-range":
        navigate("SelectProductRange", {
          state: { productRangeState },
        });
        break;
      case "model":
        navigate("SelectModel", {
          state: { modelState: modelState },
        });
        break;
      default:
        navigate("/SIM/ToBeImplemented", { state: {} });
    }
  };
  if (
    selectedCompany === null ||
    selectedRadio === "" ||
    (selectedRadio === "serial-number" && serialNumber === "")
  ) {
    return <></>;
  }
  return (
    <Row>
      <Col className="d-flex justify-content-end">
        <Button className="btn btn-primary" onClick={handleNext}>
          Next
        </Button>
      </Col>
    </Row>
  );
}
